import { render, staticRenderFns } from "./unaudited-customer.vue?vue&type=template&id=4a355bc4&scoped=true&"
import script from "./unaudited-customer.vue?vue&type=script&lang=js&"
export * from "./unaudited-customer.vue?vue&type=script&lang=js&"
import style0 from "./unaudited-customer.vue?vue&type=style&index=0&id=4a355bc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a355bc4",
  null
  
)

export default component.exports